import moment from 'moment';
import MarketingService, { normalizeList } from './marketing.service';
import ApiReports from './apireport';
import Api from './api';
import { getAllUsersSelecionModel, getRoles } from './user.service';
import { getAllSelectionModel as getAllTeamsSelectionModel } from './techinicalteam.service';

// ============================================================================================
// Agendamento e Compartilhamento de Relatórios — service (Reports API: /report/schedules/*).
// A API só grava a definição e enfileira runs; o disparo/entrega é do BackgroundTasks.
// Contrato lowercase: filtros e recorrência chegam também como JSON cru (paramsjson/recurrencejson)
// para não perder a caixa das chaves (dateStart ≠ datestart).
// ============================================================================================

// ---------------------------------------------------------------------------------------------
// Catálogo de relatórios agendáveis — espelho do backend (Mexx.Shared.Domain ReportScheduleCatalog, que sabe
// traduzir o filtro capturado para a requisição de export reexecutada em nome do dono).
// ---------------------------------------------------------------------------------------------
export const REPORT_SCHEDULE_CATALOG = [
  {
    key: 'calleds',
    labelId: 'called.report.header',
    route: 'calledreports',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],                 // calleds/excel/new → CSV (zip)
  },
  {
    key: 'calleds-organizations',
    labelId: 'calleds.organizations.report',
    route: 'calleds-organizations-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['xlsx'],                // calledsorganizations/excell/new → XLSX
  },
  {
    key: '2talk-chat',
    labelId: '2talk.chat.report',
    route: '2talk-chat-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv', 'pdf'],          // 2talk-chat-report/excell → CSV (zip) | /pdf → PDF
  },
  {
    key: 'conversation-service-report',
    labelId: 'conversation.service.report',
    route: 'conversation-service-report',
    dateParams: { start: 'DateStart', end: 'DateEnd' },
    formats: ['csv'],               // conversation-service-report/excell → CSV (zip)
  },
  // ===================== Onda 2 =====================
  {
    key: 'calleds-organizations-breach-sla',
    labelId: 'calleds.organizations.breach.sla.report',
    route: 'calleds-organizations-breach-sla-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'calleds-organizations-synthetic',
    labelId: 'calleds.organizations.synthetic.report',
    route: 'calleds-organizations-synthetic-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'calleds-origin-categories',
    labelId: 'calleds-origin-categories',
    route: 'calleds-origin-categories-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'transition-status',
    labelId: 'menu.transition.status',
    route: 'transition-status-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'category-change',
    labelId: 'menu.category.change.report',
    route: 'category-change-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'automation-execution',
    labelId: 'automations.execution',
    route: 'automation-execution-reports',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'automation',
    labelId: 'menu.automations',
    route: 'automation-reports',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'break-work',
    labelId: 'menu.report.break',
    route: 'break-work-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'webhook-execution',
    labelId: 'webhook.execution.report',
    route: 'webhook-execution-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'macro-execution',
    labelId: 'macro.execution.report',
    route: 'macro-execution-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'organization-field',
    labelId: 'organization.field.report',
    route: 'organization-field-report',
    dateParams: null,
    formats: ['csv'],
  },
  {
    key: 'called-classification',
    labelId: 'calledClassification.report.header',
    route: 'called-classification-reports',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'chat-classification',
    labelId: 'report.schedule.report.chat-classification',
    route: 'called-classification-reports',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'called-closing-error',
    labelId: 'report.schedule.report.called-closing-error',
    route: 'called-closing-error-report',
    dateParams: { start: 'startDate', end: 'endDate' },
    formats: ['csv'],
  },
  {
    key: 'quantitative-chats',
    labelId: 'report.schedule.report.quantitative-chats',
    route: 'quantitative-chats-report',
    dateParams: null,
    formats: ['csv'],
  },
  {
    key: '2talk-satisfaction-survey',
    labelId: '2talk.satisfation.survey.report',
    route: '2talk-satisfactionsurvey-report',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'clicks-satisfaction-survey',
    labelId: 'menu.2talk.clicks.on.satisfaction.survey',
    route: 'clicks-on-satisfaction-survey',
    dateParams: { start: 'dateStart', end: 'dateEnd' },
    formats: ['csv'],
  },
  {
    key: 'messaging-channel-log',
    labelId: 'report.schedule.report.messaging-channel-log',
    route: 'messaging-channel-log-report',
    dateParams: { start: 'startDate', end: 'endDate' },
    formats: ['csv'],
  },
  {
    key: 'ai-suggestion',
    labelId: 'report.schedule.report.ai-suggestion',
    route: 'ai-suggestion-report',
    dateParams: { start: 'startDate', end: 'endDate' },
    formats: ['csv'],
  },
  {
    key: 'llm-usage',
    labelId: 'report.schedule.report.llm-usage',
    route: 'llm-usage-report',
    dateParams: { start: 'startDate', end: 'endDate' },
    formats: ['csv'],
  },
  {
    key: 'feedback-article',
    labelId: 'report.schedule.report.feedback-article',
    route: 'reports/feedback-article',
    dateParams: { start: 'startDate', end: 'endDate' },
    formats: ['csv'],
  },
  {
    key: 'user-activity',
    labelId: 'report.schedule.report.user-activity',
    route: 'usage/user-activity',
    dateParams: { start: 'startDate', end: 'endDate' },
    formats: ['csv'],
  },
];

export const getCatalogEntry = (key) => REPORT_SCHEDULE_CATALOG.find(c => c.key === key) || null;

// ---------------------------------------------------------------------------------------------
// Captura da requisição de filtro (o que a tela mandou no paginate).
// ---------------------------------------------------------------------------------------------
// Params de paginação/ordenação não fazem parte do "filtro" do relatório.
const IGNORED_PARAMS = ['page', 'pageSize', 'pagesize', 'sort', 'order', 'range', 'techuser'];

// "/report/calleds/paginate?page=1&org=3&dateStart=2026-09-01" → { path, params }
export const parseRequestUrl = (url = '') => {
  const [path, qs = ''] = String(url).split('?');
  const params = {};
  qs.split('&').filter(Boolean).forEach(pair => {
    const idx = pair.indexOf('=');
    const k = idx >= 0 ? pair.substring(0, idx) : pair;
    const v = idx >= 0 ? pair.substring(idx + 1) : '';
    if (!k || IGNORED_PARAMS.includes(k)) return;
    let decoded = v;
    try { decoded = decodeURIComponent(v); } catch (e) { /* mantém cru */ }
    params[k] = decoded;
  });
  return { path, params };
};

// Parâmetros com rótulo próprio (report.schedule.param.<nome>). Desconhecidos aparecem pelo nome cru.
export const KNOWN_PARAM_LABELS = [
  'org', 'organizationId', 'techteam', 'status', 'statusId', 'priority', 'groupId', 'loc', 'dep',
  'slasolution', 'slaservice', 'requestingUserEmail', 'requestingUserName', 'requestingUserDocument',
  'userTechId', 'filterByTags', 'tagsIds', 'search', 'filter', 'mode', 'customfieldids', 'classification',
  'classificationType', 'messageProviderId', 'channelId', 'id', 'requestUser', 'assignedUser',
  'closingStatusIds', 'hasTicket', 'onlyIa', 'onlyHuman', 'filterByDate', 'allorganizationschecked',
  // Onda 2
  'automationTypeId', 'breakReasonIds', 'userAgentId', 'webhookIds', 'automationIds', 'eventTypeCodes', 'deliveryStatus', 'sources', 'macroids', 'organizationIds', 'categoryIds', 'fieldTypeIds', 'active', 'isRequired', 'filterOriginPerDate', 'location', 'originofsurveyresponse', 'techinicalTeamId', 'calledId', 'archived', 'day', 'month', 'year', 'messageproviderid', 'minclassification', 'maxclassification', 'requestingUserId', 'logType', 'success', 'registeredPhoneNumberId', 'chatId', 'errorCode', 'userId', 'llmId', 'origin', 'relationedId', 'actionKind', 'entityType', 'entityId', 'ip', 'originids', 'categoriesids',
];

// Params técnicos: vão no filtro salvo (o motor usa), mas não são filtro visível.
const HIDDEN_PARAMS = ['customfieldnamestoback', 'code'];

const isEmptyValue = (v) => v === undefined || v === null || v === '' || v === '0' || v === 'undefined' || v === 'null' || v === 'false' || v === 'NaN';

// Resumo legível dos filtros capturados: [{ param, labelId|label, value|valueId, count }].
// Ids viram contagem ("2 selecionados") — o nome real fica no snapshot do backend (F2).
export const buildFilterSummary = (params = {}, catalogEntry = null) => {
  const dateKeys = catalogEntry && catalogEntry.dateParams ? [catalogEntry.dateParams.start, catalogEntry.dateParams.end] : [];
  return Object.keys(params)
    .filter(k => !dateKeys.includes(k) && !HIDDEN_PARAMS.includes(k) && !isEmptyValue(params[k]))
    .map(k => {
      const raw = String(params[k]);
      const labelId = KNOWN_PARAM_LABELS.includes(k) ? `report.schedule.param.${k}` : null;
      if (raw === 'true') return { param: k, labelId, label: k, valueId: 'report.schedule.value.yes' };
      if (/^\d+(,\d+)*$/.test(raw)) return { param: k, labelId, label: k, count: raw.split(',').filter(x => x && x !== '0').length };
      return { param: k, labelId, label: k, value: raw };
    })
    .filter(s => s.count === undefined || s.count > 0);
};

// ---------------------------------------------------------------------------------------------
// Período relativo (resolvido no fuso do agendamento a cada disparo, no backend).
// ---------------------------------------------------------------------------------------------
export const RELATIVE_PERIODS = [
  'yesterday', 'today', 'last_7_days', 'last_15_days', 'last_30_days',
  'current_week', 'previous_week', 'current_month', 'previous_month',
];

// Intervalo [start, end] (moment) que um período relativo cobre tendo `ref` como "agora".
export const resolveRelativePeriod = (period, ref = moment()) => {
  const r = moment(ref);
  switch (period) {
    case 'yesterday': return [r.clone().subtract(1, 'day').startOf('day'), r.clone().subtract(1, 'day').endOf('day')];
    case 'today': return [r.clone().startOf('day'), r.clone().endOf('day')];
    case 'last_7_days': return [r.clone().subtract(7, 'days').startOf('day'), r.clone().subtract(1, 'day').endOf('day')];
    case 'last_15_days': return [r.clone().subtract(15, 'days').startOf('day'), r.clone().subtract(1, 'day').endOf('day')];
    case 'last_30_days': return [r.clone().subtract(30, 'days').startOf('day'), r.clone().subtract(1, 'day').endOf('day')];
    case 'current_week': return [r.clone().startOf('week'), r.clone().endOf('day')];
    case 'previous_week': return [r.clone().subtract(1, 'week').startOf('week'), r.clone().subtract(1, 'week').endOf('week')];
    case 'current_month': return [r.clone().startOf('month'), r.clone().endOf('day')];
    case 'previous_month': return [r.clone().subtract(1, 'month').startOf('month'), r.clone().subtract(1, 'month').endOf('month')];
    default: return [null, null];
  }
};

// Sugere o período relativo mais próximo do que o usuário acabou de filtrar.
export const inferRelativePeriod = (params = {}, catalogEntry = null) => {
  if (!catalogEntry || !catalogEntry.dateParams) return 'last_30_days';
  const s = moment(params[catalogEntry.dateParams.start], 'YYYY-MM-DD', true);
  const e = moment(params[catalogEntry.dateParams.end], 'YYYY-MM-DD', true);
  if (!s.isValid() || !e.isValid()) return 'last_30_days';
  const prevMonth = moment().subtract(1, 'month');
  if (s.isSame(prevMonth.clone().startOf('month'), 'day') && e.isSame(prevMonth.clone().endOf('month'), 'day')) return 'previous_month';
  if (s.isSame(moment().startOf('month'), 'day')) return 'current_month';
  const days = e.diff(s, 'days') + 1;
  if (days <= 1) return 'yesterday';
  if (days <= 7) return 'last_7_days';
  if (days <= 15) return 'last_15_days';
  return 'last_30_days';
};

// ---------------------------------------------------------------------------------------------
// Normalizers (backend devolve lowercase — LowercaseContractResolver).
// ---------------------------------------------------------------------------------------------
export const normalizeRecipient = (r = {}) => ({
  type: r.type,                                           // user | team | role | email | marketing_list
  id: r.id ?? r.targetid ?? null,
  name: r.name ?? r.target ?? '',
  channel: r.channel ?? 'email',                          // email (V1) | whatsapp (V2)
});

const parseJson = (v) => {
  if (!v || typeof v !== 'string') return null;
  try { return JSON.parse(v); } catch (e) { return null; }
};

// Recorrência (ScheduleRecurrence). Aceita camelCase (JSON cru) ou lowercase (contrato da API).
const normalizeRecurrence = (r) => (r ? {
  freq: r.freq ?? r.Freq ?? 'weekly',
  time: r.time ?? r.Time ?? '08:00',
  interval: r.interval ?? r.Interval ?? 1,
  weekdays: r.weekdays ?? r.Weekdays ?? [],
  monthlyMode: r.monthlyMode ?? r.monthlymode ?? r.MonthlyMode ?? 'dayOfMonth',
  dayOfMonth: r.dayOfMonth ?? r.dayofmonth ?? r.DayOfMonth ?? 1,
  nth: r.nth ?? r.Nth ?? 1,
  nthWeekday: r.nthWeekday ?? r.nthweekday ?? r.NthWeekday ?? 1,
  endMode: r.endMode ?? r.endmode ?? r.EndMode ?? 'never',
  endCount: r.endCount ?? r.endcount ?? r.EndCount ?? 5,
  endDate: r.endDate ?? r.enddate ?? r.EndDate ?? '',
} : null);

export const normalizeSchedule = (s = {}) => ({
  id: s.id,
  name: s.name ?? '',
  reportKey: s.reportkey ?? s.reportKey,
  ownerId: s.ownerid ?? s.ownerId,
  ownerName: s.ownername ?? s.ownerName ?? '',
  requestPath: s.requestpath ?? s.requestPath ?? '',
  params: parseJson(s.paramsjson ?? s.paramsJson) ?? s.params ?? {},
  periodMode: s.periodmode ?? s.periodMode ?? 'relative',  // relative | fixed
  relativePeriod: s.relativeperiod ?? s.relativePeriod ?? 'last_30_days',
  format: s.format ?? 'xlsx',
  scheduleMode: s.schedulemode ?? s.scheduleMode ?? 'recurring', // once | recurring
  onceAt: s.onceat ?? s.onceAt ?? '',
  recurrence: normalizeRecurrence(parseJson(s.recurrencejson ?? s.recurrenceJson) ?? s.recurrence),
  timezone: s.timezone ?? 'America/Sao_Paulo',
  status: s.status ?? 'active',                           // active | paused | paused_by_system
  statusReason: s.statusreason ?? s.statusReason ?? '',
  deliveryMode: s.deliverymode ?? s.deliveryMode ?? 'auto', // auto (anexa ≤ limite, senão link) | link
  linkExpirationDays: s.linkexpirationdays ?? s.linkExpirationDays ?? 7,
  skipIfEmpty: s.skipifempty ?? s.skipIfEmpty ?? true,
  includeOwner: s.includeowner ?? s.includeOwner ?? true,
  recipients: Array.isArray(s.recipients) ? s.recipients.map(normalizeRecipient) : [],
  nextRunAt: s.nextrunat ?? s.nextRunAt ?? null,
  lastRunAt: s.lastrunat ?? s.lastRunAt ?? null,
  lastRunStatus: s.lastrunstatus ?? s.lastRunStatus ?? null,
  createdAt: s.createdat ?? s.createdAt ?? null,
});

export const normalizeRun = (r = {}) => ({
  id: r.id,
  runNumber: r.runnumber ?? r.runNumber,
  scheduledFor: r.scheduledfor ?? r.scheduledFor,
  finishedAt: r.finishedat ?? r.finishedAt ?? null,
  status: r.status,                                       // queued | processing | delivered | failed | skipped_empty
  triggeredBy: r.triggeredby ?? r.triggeredBy ?? 'scheduler', // scheduler | manual | test
  rowCount: r.rowcount ?? r.rowCount ?? 0,
  recipientsCount: r.recipientscount ?? r.recipientsCount ?? 0,
  delivery: r.delivery ?? 'link',                         // attachment | link
  error: r.error ?? '',
  // Destinatários descartados NO ENVIO: [{ target, reason: no_email | domain_blocked }] (JSON cru vindo do backend).
  discarded: (parseJson(r.discardedrecipientsjson ?? r.discardedRecipientsJson) || []).map(d => ({
    target: d.target ?? d.Target ?? '—',
    reason: d.reason ?? d.Reason ?? 'no_email',
  })),
  // Só na lista de envios de teste (sem agendamento: nome/relatório vêm do snapshot).
  name: r.name ?? '',
  reportKey: r.reportkey ?? r.reportKey ?? '',
});

// Destinatário de uma execução — status EFETIVO: queued (na fila da Mail) | sent | failed | discarded.
export const normalizeRunRecipient = (r = {}) => ({
  id: r.id,
  type: r.recipienttype ?? r.recipientType ?? 'email',
  name: r.name ?? '',
  email: r.email ?? '',
  status: r.status ?? 'queued',
  discardReason: r.discardreason ?? r.discardReason ?? null,
  error: r.error ?? '',
  sentAt: r.sentat ?? r.sentAt ?? null,
  attempts: r.attempts ?? 0,
});

export const normalizeRunDetail = (r = {}) => ({
  ...normalizeRun(r),
  scheduleId: r.reportscheduleid ?? r.reportScheduleId ?? null,
  requestedByName: r.requestedbyname ?? r.requestedByName ?? '',
  format: r.format ?? '',
  deliveryMode: r.deliverymode ?? r.deliveryMode ?? 'auto',
  attempt: r.attempt ?? 0,
  startedAt: r.startedat ?? r.startedAt ?? null,
  periodStart: r.periodstart ?? r.periodStart ?? null,
  periodEnd: r.periodend ?? r.periodEnd ?? null,
  rowCount: r.rowcount ?? r.rowCount ?? null,
  recipients: Array.isArray(r.recipients) ? r.recipients.map(normalizeRunRecipient) : [],
});

// ---------------------------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------------------------
const BASE = '/report/schedules';

// { success:false, errors } vira rejeição — quem consome trata tudo no .catch (err.response.data.errors[0]).
const unwrap = (r) => (r && r.data && r.data.success === false ? Promise.reject({ response: { data: r.data } }) : r);
const onError = (err) => {
  if (err && err.response && err.response.status === 401) Api.kickoff(err);
  return Promise.reject(err);
};
const mapData = (fn) => (r) => {
  if (r && r.data && r.data.data !== undefined && r.data.data !== null) r.data.data = fn(r.data.data);
  return r;
};
const asArray = (raw) => (Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : []));

// Cache dos domínios permitidos (validação síncrona no assistente; o backend revalida no save E no disparo).
let allowedDomainsCache = [];

const ReportScheduleService = {
  // scope: mine | all (all só para admin — o backend ignora para os demais).
  list: (scope) => ApiReports.get(`${BASE}?scope=${scope === 'all' ? 'all' : 'mine'}`)
    .then(unwrap).then(mapData(list => asArray(list).map(normalizeSchedule))).catch(onError),

  get: (id) => ApiReports.get(`${BASE}/${id}`).then(unwrap).then(mapData(normalizeSchedule)).catch(onError),

  save: (payload) => (payload.id
    ? ApiReports.put(`${BASE}/${payload.id}`, payload)
    : ApiReports.post(BASE, payload))
    .then(unwrap).then(mapData(normalizeSchedule)).catch(onError),

  setStatus: (id, status) => ApiReports.post(`${BASE}/${id}/status`, { status }).then(unwrap).then(mapData(normalizeSchedule)).catch(onError),

  duplicate: (id) => ApiReports.post(`${BASE}/${id}/duplicate`).then(unwrap).then(mapData(normalizeSchedule)).catch(onError),

  // Admin: transfere a posse (ex.: dono desligado). O escopo dos dados passa a ser o do NOVO dono; fica pausado.
  transferOwner: (id, user) => ApiReports.post(`${BASE}/${id}/transfer-owner`, { userId: user.id }).then(unwrap).then(mapData(normalizeSchedule)).catch(onError),

  remove: (id) => ApiReports.delete(`${BASE}/${id}`).then(unwrap).catch(onError),

  // Executar agora: só enfileira um run (quem executa é o BackgroundTasks).
  runNow: (id) => ApiReports.post(`${BASE}/${id}/run-now`).then(unwrap).catch(onError),

  // Teste antes de salvar: entrega só para o próprio usuário (sem persistir o agendamento).
  sendTest: (payload) => ApiReports.post(`${BASE}/test`, payload).then(unwrap).catch(onError),

  getRuns: (id) => ApiReports.get(`${BASE}/${id}/runs`).then(unwrap).then(mapData(list => asArray(list).map(normalizeRun))).catch(onError),

  // Meus envios de teste (não pertencem a nenhum agendamento).
  getTestRuns: () => ApiReports.get(`${BASE}/runs/tests`).then(unwrap).then(mapData(list => asArray(list).map(normalizeRun))).catch(onError),

  // Detalhe de uma execução + status individual de cada destinatário.
  getRunDetail: (runId) => ApiReports.get(`${BASE}/runs/${runId}`).then(unwrap).then(mapData(normalizeRunDetail)).catch(onError),

  // Fontes dos destinatários: endpoints existentes do 2DO (usuários/equipes/perfis) + listas do Marketing (2Talk).
  getRecipientSources: () => Promise.all([
    getAllUsersSelecionModel().catch(() => []),
    getAllTeamsSelectionModel().catch(() => []),
    getRoles().catch(() => []),
    MarketingService.listLists().then(r => ((r.data && r.data.success && Array.isArray(r.data.data)) ? r.data.data.map(normalizeList) : [])).catch(() => []),
  ]).then(([users, teams, roles, lists]) => ({
    data: {
      success: true,
      data: {
        users: asArray(users).map(u => ({ id: u.id, name: u.name })),
        teams: asArray(teams).map(t => ({ id: t.id, name: t.name })),
        roles: asArray(roles).map(r => ({ id: r.id, name: r.displayname ?? r.displayName ?? r.name })),
        marketingLists: lists.map(l => ({ id: l.id, name: l.name, total: l.total })),
      },
    },
  })),

  // Detalhe COMPLETO dos filtros: o backend troca ids por nomes (o mesmo resolver vai no corpo do e-mail).
  describeFilters: (reportKey, params) => ApiReports.post(`${BASE}/describe-filters`, { reportKey, params })
    .then(unwrap)
    .then(mapData(rows => asArray(rows).map(f => {
      const param = f.param;
      const values = Array.isArray(f.values) ? f.values : [];
      const labelId = param === '__period' ? 'report.schedule.filters.filteredPeriod'
        : (KNOWN_PARAM_LABELS.includes(param) ? `report.schedule.param.${param}` : null);
      const isYes = values.length === 1 && values[0] === 'true';
      return { param, labelId, label: param, valueId: isYes ? 'report.schedule.value.yes' : undefined, values: isYes ? [] : values };
    })))
    .catch(onError),

  // Membros ATUAIS de um destinatário dinâmico. eligibility: ok | no_email | domain_blocked.
  getRecipientMembers: (type, id) => {
    if (type === 'marketing_list') {
      return MarketingService.getListContactsForEdit(id).then(r => {
        const rows = (r.data && r.data.success && Array.isArray(r.data.data)) ? r.data.data : [];
        return {
          data: {
            success: true,
            data: rows.map(c => {
              const email = c.email ?? '';
              const eligibility = !email ? 'no_email' : ReportScheduleService.isEmailAllowed(email) ? 'ok' : 'domain_blocked';
              return { name: c.name || c.phone || '—', email, phone: c.phone ?? '', eligibility };
            }),
          },
        };
      });
    }
    return ApiReports.get(`${BASE}/members/${type}/${id}`).then(unwrap).catch(onError);
  },

  getAllowedDomains: () => ApiReports.get(`${BASE}/settings/allowed-domains`).then(unwrap)
    .then(r => { allowedDomainsCache = asArray(r.data && r.data.data); return r; }).catch(onError),
  saveAllowedDomains: (domains) => ApiReports.put(`${BASE}/settings/allowed-domains`, { allowedDomains: domains }).then(unwrap)
    .then(r => { allowedDomainsCache = asArray(r.data && r.data.data); return r; }).catch(onError),

  // Mesmo critério que o backend aplica no save E no disparo.
  isEmailAllowed: (email) => {
    const domain = String(email || '').split('@')[1];
    return !!domain && allowedDomainsCache.includes(domain.toLowerCase());
  },

  // Link do e-mail "Não quero mais receber" (página pública).
  unsubscribe: (token) => ApiReports.post(`${BASE}/unsubscribe/${token}`).then(unwrap),
};

export default ReportScheduleService;
